const f = (n) => Object.fromEntries(
  Object.entries(n).map(([t, r]) => r instanceof Array ? r.every((e) => typeof e == "object") ? [t, r.map(f)] : [t, r.filter((e) => !!e)] : [t, r])
);
export {
  f as default
};
